import { City } from "country-state-city";
import React, { useEffect, useState } from "react";
import Select from "react-select";

export interface CityProps {
  value: string;
  label: string;
}

interface CityDropdownProps {
  stateCode: string;
  selectedCity?: string | null;
  onCityChange: (selectedOption: CityProps | null) => void;
}

const CityDropdown: React.FC<CityDropdownProps> = ({
  stateCode,
  selectedCity,
  onCityChange
}) => {
  const [cities, setCities] = useState<CityProps[]>([]);

  const formatCityForDropdown = (cities: any) => {
    return cities.map((city: any) => {
      return { value: city.name, label: city.name };
    })
  };

  useEffect(() => {
    if (stateCode) {
      const fetchedCities = City.getCitiesOfState('IN', stateCode);
      const enhancedCities = formatCityForDropdown(fetchedCities);
      setCities(enhancedCities);
    }
  }, [stateCode]);

  return (
    <div className="form-group">
      <label htmlFor="selectCity">
        <strong>Select City</strong>
      </label>
      <Select
        options={cities}
        onChange={onCityChange}
        value={
          selectedCity
            ? formatCityForDropdown(City.getCitiesOfState('IN', stateCode))
              .find((city: any) => city.value === selectedCity)
            : null
        }
        isSearchable={true}
        placeholder="Select a City" />
    </div>
  );
};

export default CityDropdown;